import InstitutionModel from '@/dex-shared/models/InstitutionModel';

export default {
  institutionById: (state: any, getters: any) => (institutionId: number) => {
    const institution = state.institutions[institutionId];
    if (institution) return new InstitutionModel(institution, getters);
    return {};
  },
  allInstitutions: (state: any, getters: any) => {
    return Object.values(state.institutions).map(
      (institution: any) => new InstitutionModel(institution, getters),
    );
  },
};
